import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useMsal } from "@azure/msal-react";
import { HiMiniArrowLeftOnRectangle } from "react-icons/hi2";
import { HiMenu } from "react-icons/hi";

export const Dashboardheader = ({ isDrawerOpen, toggleDrawer }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const accDetails = instance.getActiveAccount();
  const userName = accDetails?.name;
  const firstName = userName ? userName.split(" ")[0] : "";

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/');
    instance.logoutRedirect();
  };

  const handleProfile = () => {
    navigate("/employee", { state: { disableEmail: true } });
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="sticky top-0 z-[9] flex w-full bg-white drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
      <div className="flex flex-1 items-center justify-between py-4 px-4 shadow-2 md:px-6 2xl:px-11">
        <div className="flex items-center">
          {/* {!isDrawerOpen && (
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <span
                className="border-2 border-black rounded-md p-1"
                onClick={toggleDrawer}
              >
                <HiMenu className="text-xl cursor-pointer" />
              </span>
              <img className="w-32" src="/jetz-logo.png" alt="Logo" />
            </div>
          )} */}
        </div>
        <div className="relative" ref={dropdownRef}>
          <div
            className="flex items-center gap-2 sm:gap-4 cursor-pointer"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <span className="hidden text-right lg:block">
              <span className="block text-sm font-medium text-black dark:text-white">
                {firstName}
              </span>
            </span>
            <FaUserCircle style={{ fontSize: "23px" }} />
            <IoIosArrowDown />
          </div>
          {isDropdownOpen && (
            <div className="absolute right-0 mt-4 w-48 bg-white rounded-md overflow-hidden shadow-lg z-10">
              <button
                className="flex items-center gap-3 w-full py-4 px-4 text-left text-md font-semibold text-gray-800 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark"
                onClick={handleProfile}
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  className="icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="22"
                  height="22"
                >
                  <path d="M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm89.6 32h-11.1a174.8 174.8 0 0 1-156.9 0H133.3A133.3 133.3 0 0 0 0 421.3V456a24 24 0 0 0 24 24H424a24 24 0 0 0 24-24v-34.7A133.3 133.3 0 0 0 313.6 288z" />
                </svg>{" "}
                Profile
              </button>
              <button
                className="flex items-center gap-3 w-full py-4 px-4 text-left text-md font-semibold text-gray-800 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark"
                onClick={handleLogout}
              >
                {/* <HiMiniArrowLeftOnRectangle className='mt-1 text-2xl'/> */}
                <svg
                  className="fill-current"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5375 0.618744H11.6531C10.7594 0.618744 10.0031 1.37499 10.0031 2.26874V4.64062C10.0031 5.05312 10.3469 5.39687 10.7594 5.39687C11.1719 5.39687 11.55 5.05312 11.55 4.64062V2.23437C11.55 2.16562 11.5844 2.13124 11.6531 2.13124H15.5375C16.3625 2.13124 17.0156 2.78437 17.0156 3.60937V18.3562C17.0156 19.1812 16.3625 19.8344 15.5375 19.8344H11.6531C11.5844 19.8344 11.55 19.8 11.55 19.7312V17.3594C11.55 16.9469 11.2062 16.6031 10.7594 16.6031C10.3125 16.6031 10.0031 16.9469 10.0031 17.3594V19.7312C10.0031 20.625 10.7594 21.3812 11.6531 21.3812H15.5375C17.2219 21.3812 18.5625 20.0062 18.5625 18.3562V3.64374C18.5625 1.95937 17.1875 0.618744 15.5375 0.618744Z"
                    fill=""
                  />
                  <path
                    d="M6.05001 11.7563H12.2031C12.6156 11.7563 12.9594 11.4125 12.9594 11C12.9594 10.5875 12.6156 10.2438 12.2031 10.2438H6.08439L8.21564 8.07813C8.52501 7.76875 8.52501 7.2875 8.21564 6.97812C7.90626 6.66875 7.42501 6.66875 7.11564 6.97812L3.67814 10.4844C3.36876 10.7938 3.36876 11.275 3.67814 11.5844L7.11564 15.0906C7.25314 15.2281 7.45939 15.3312 7.66564 15.3312C7.87189 15.3312 8.04376 15.2625 8.21564 15.125C8.52501 14.8156 8.52501 14.3344 8.21564 14.025L6.05001 11.7563Z"
                    fill=""
                  />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Dashboardheader;
